import React, { Component } from 'react';
import { applicationModes, sections, applicationRoutes } from '../constants';
import DemoListHeaderView from './DemoListHeaderView';
import FooterView from './FooterView';

const baseRoute = './';

const defaultRoute = baseRoute + applicationRoutes.DEFAULT;
const gAutoRoute = baseRoute + applicationRoutes.G_AUTO;
const qAutoRoute = baseRoute + applicationRoutes.Q_AUTO;
const multiCdnRoute = baseRoute + applicationRoutes.MULTI_CDN;

export default class DemoList extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    /*
    IMPORTANT:
    sitemap.xml is maintained manually in sitemap.xml since creating it is extremely hard
    to maintain it automatically when using React router.

    When updating internal link in this file, update sitemap.xml as well
    */
    return (<div id="wrapper">
        <DemoListHeaderView />
        <div className="container">
          <main id="demo-list-main" role="main">
            <div>
              <h1>Cloudinary Demos</h1>
              <ul>
                <li>
                  <a href={defaultRoute}>
                    <img src="https://res.cloudinary.com/cloudinary/image/upload/c_fill,w_150,h_100,dpr_2.0/demo_screenshot_ecommerce.jpg" width="150" height="100" alt="Interactive Image Manipulation - Demo" />
                    <span>Interactive Image Manipulation - Demo</span>
                  </a>
                </li>
                <li>
                  <a href={gAutoRoute}>
                    <img src="https://res.cloudinary.com/cloudinary/image/upload/c_fill,w_150,h_100,dpr_2.0/demo_screenshot_g_auto.jpg" width="150" height="100" alt="Automatic Content-Aware Cropping - Demo" />
                    <span>Automatic Content-Aware Cropping - Demo</span>
                  </a>
                </li>
                <li>
                  <a href={qAutoRoute}>
                    <img src="https://res.cloudinary.com/cloudinary/image/upload/c_fill,w_150,h_100,dpr_2.0/demo_screenshot_optimization.jpg" width="150" height="100" alt="Intelligent Content-Aware Encoding - Demo" />
                    <span>Intelligent Content-Aware Encoding - Demo</span>
                  </a>
                </li>
                <li>
                  <a href="http://www.responsivebreakpoints.com/">
                    <img src="https://res.cloudinary.com/cloudinary/image/upload/c_fill,w_150,h_100,dpr_2.0/demo_screenshot_responsive_breakpoints.jpg" width="150" height="100" alt="Responsive Breakpoints Generator - Tool" />
                    <span>Responsive Breakpoints Generator - Tool</span>
                  </a>
                </li>
                <li>
                  <a href="https://demo.cloudinary.com/video-player/">
                    <img src="https://res.cloudinary.com/demo/video/upload/so_0,du_3/vs_30,e_loop/w_300,h_200,c_fill/q_50,b_white/fl_lossy.animated,f_auto/rafting_short.gif" width="150" height="100" alt="Video Player - Demo" />
                    <span>Video Player - Demo</span>
                  </a>
                </li>
                <li>
                  <a href="https://demo.cloudinary.com/video/">
                    <img src="https://res.cloudinary.com/demo/video/upload/so_5,du_9/vs_30,e_loop/w_300,h_200,c_fill/q_50,b_white/fl_lossy.animated,f_auto/what_is_cloudinary_small.gif" width="150" height="100" alt="Video Transcoding - Demo" />
                    <span>Video Transcoding - Demo</span>
                  </a>
                </li>
                <li>
                  <a href="https://demo.cloudinary.com/live/">
                    <img src="https://cloudinary-res.cloudinary.com/image/upload/c_fill,w_150,h_100,dpr_2.0/video-stream.jpg" width="150" height="100" alt="Live Video - Demo" />
                    <span>Live Video - Demo</span>
                  </a>
                </li>
                <li>
                  <a href={multiCdnRoute}>
                    <img src="https://res.cloudinary.com/cloudinary/image/asset/c_fill,w_150,h_100,dpr_2.0/image_optimization_content_delivery_network-e3df905c0bbe8e94e28a9893882ba141.png" width="150" height="100" alt="Multiple CDN solution - Demo" />
                    <span>Multiple CDN solution - Demo</span>
                  </a>
                </li>
                <li>
                  <a href="http://ericportis.com/etc/white-house-ch/">
                    <img src="https://res.cloudinary.com/cloudinary/image/upload/c_fill,w_150,h_100,dpr_2.0/demo_screenshot_client_hints.jpg" width="150" height="100" alt="Auto Responsive Images (Client Hints) - Sample" />
                    <span>
                      Automatic Responsive Images With Client Hints - Sample
                    </span>
                  </a>
                </li>
                <li>
                  <a href="http://edgedemo.cloudinary.com/">
                    <img src="https://res.cloudinary.com/cloudinary/image/upload/c_fill,w_150,h_100,dpr_2.0/demo_screenshot_live_sharing.jpg" width="150" height="100" alt="Live Photo Sharing - Demo" />
                    <span>Live Photo Sharing - Demo</span>
                  </a>
                </li>
              </ul>
            </div>
          </main>
        </div>
        <FooterView additionalClassName="demoListFooter" />
      </div>);
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/DemoList.js
 **/